// Actions
export const INIT = '@@app/INIT'
export const READY = '@@app/READY'

// Reducer
const INITIAL_STATE = {
  ready: false,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case READY:
      return {
        ready: action.ready,
      }

    default:
      return state
  }
}

// Actions Creators
export const initApp = () => ({
  type: INIT,
})

export const readyApp = (ready) => ({
  type: READY,
  ready,
})
